import { Link } from "react-router-dom";
import { useState, useEffect } from "react";

export default function Header() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 100);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <header
      className={`sticky top-0 z-50 shadow-sm transition-all duration-300 ${isScrolled ? "bg-white" : "bg-[#e4eef9]"}`}
    >
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col items-center py-3 md:flex-row md:justify-between">
          {/* Logos - centrés sur mobile, à gauche sur desktop */}
          <div className="flex items-center justify-center mb-3 md:mb-0">
           <Link to="/">
             <img
               src="/assets/images/logo-sante-flex.png"
               alt="Sante Flex"
               className="h-[70px] w-[auto] rounded-lg"
             />
           </Link>
          </div>
          {/* Boutons - centrés sur mobile, à droite sur desktop */}
          <div className="flex justify-center gap-2">
            <a
              href="https://portail.qualitas-assurance.com"
              className="rounded-md border border-secondary px-4 py-2 text-sm font-medium text-secondary transition hover:bg-secondary hover:text-light"
            >
              Se connecter
            </a>
            <Link
              to="/step-0"
              className="rounded-md border border-primary bg-primary px-4 py-2 text-sm font-medium text-secondary transition hover:bg-primary-dark hover:text-light"
            >
              Je souscris
            </Link>
          </div>
        </div>
      </div>
    </header>
  );
}
